module.exports = __webpack_public_path__ + "img/companion-category.1eda37e1.png";